import { Component } from '@angular/core';
import { UiModule } from '@components/ui/ui-module';

@Component({
  selector: 'lgb-cgu',
  imports: [
    UiModule
  ],
  templateUrl: './cgu.html',
  styleUrl: './cgu.css',
})
export class Cgu {

}
